import type { UserData } from 'chaika-frontend-types/frontend-cms';

export interface InitialsParams {
    firstName?: string;
    lastName?: string;
    patronymic?: string;
}

export function getInitials(user: UserData): string {
    return formatInitials(user);
}

export function formatInitials({ firstName, lastName, patronymic }: InitialsParams): string {
    return `${lastName || ''}${getFirstLetter(firstName)}${patronymic ? getFirstLetter(patronymic) : ''}`;
}

function getFirstLetter(name?: string): string {
    return name ? ` ${name[0]}.` : '';
}
